<template>
    <div class="tab-content">
        <!-- <el-tabs activeName="first">
            <el-tab-pane :label="$t('project_tab_progress_first')" name="first">
                <el-card> -->
                    <div class="buttons" v-show="hide">
                        <div>
                            <el-button :disabled="!projectPermission.addProgress" v-if="startBtn" @click="startTaskOpenModal" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-play">{{selectedRow.taskStatus == 3 ? ' ' + $t('project_tab_progress_first_btn_restart') : ' ' + $t('project_tab_progress_first_btn_start')}}</el-button>
                            <el-button :disabled="!projectPermission.addProgress" v-if="addBtn" @click="addProgressNote" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('project_tab_progress_first_btn_addProgressNote')}}</el-button>
                            <el-button :disabled="!projectPermission.holdProgress" v-if="holdBtn" @click="holdTaskOpen" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-pause"> {{$t('project_tab_progress_first_btn_hold')}}</el-button>
                            <el-button :disabled="!projectPermission.doneProgress || !(Math.round(progressData[0].progress) == 100)" v-if="doneBtn && progressData.length" @click="doneTaskOpen" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-check"> {{$t('project_tab_progress_first_btn_done')}}</el-button>
                            <el-button :disabled="!projectPermission.addProgress" v-if="reopenBtn" @click="restartTaskOpen" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-sync"> {{$t('project_tab_progress_first_btn_reopen')}}</el-button>
                            <!-- <span style="margin-left: 10px; font-size: 14px;">Total Time: {{totalTimeH}}:{{totalTimeM}}</span> -->
                            <!-- <el-button v-show="timerBtn" @click="timer" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-stopwatch"> Add Timer</el-button> -->
                        </div>
                        <div>
                            <el-tag type="info" size="medium" style="margin-left: 10px; margin-right: 0px; font-size: 14px;">{{$t('project_tab_progress_first_totalTime')}}: {{totalTimeH}}:{{totalTimeM}}</el-tag>
                            <!-- <span style="margin-left: 10px; margin-right: 20px; font-size: 14px;">Total Time: {{totalTimeH}}:{{totalTimeM}}</span> -->
                            <!-- <el-button v-show="timerBtn" @click="timer" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-stopwatch"> Add Timer</el-button> -->
                        </div>
                    </div>
                    <!-- {{timerList}} -->
                    <div class="my-window" id="my-window">
                        <el-timeline v-show="timerList.length || progressData.length" style="padding-top: 20px;">

                            <!-- TIMER -->
                            <el-timeline-item
                                v-for="item in timerList"
                                :key="item.startDate"
                                :timestamp="timestamp(item.startDate, item.companyUser.user.fullName)"
                                placement="top">
                                <el-card class="card" style="background: #888; color: white;" :id="item.id">
                                    <div class="card__header">
                                        <div class="card__time">
                                            <div class="photo-group">
                                                <img v-if="item.companyUser.user.avatarUrl" :src="item.companyUser.user.avatarUrl">
                                            </div>
                                            <div style="margin-right: 10px;">
                                                <img v-show="item.status == 1" src="@/assets/img/live/live1.gif" width="12px;">
                                            </div>
                                            <div>
                                                {{$t('project_tab_progress_first_totalTime')}}: {{totalTime(item.startDate, item.time, item.totalTime, item.status)}}
                                            </div>
                                        </div><br>
                                        <div v-if="companyLayout.companyUserId == item.companyUserId" class="card__edit">
                                            <el-button v-if="item.status == 1" @click="pauseTimer(item.id, item.projectId, item.projectTaskId)" type="warning" plain size="mini" icon="fas fa-pause"></el-button>
                                            <el-button v-else @click="restartTimer(item.id, item.projectId, item.projectTaskId)" type="primary" plain size="mini" icon="fas fa-play"></el-button>
                                            <el-button @click="stopTimer(item.id, item.startDate, item.time, item.totalTime)" type="danger" plain size="mini" icon="fas fa-stop"></el-button>
                                        </div>
                                    </div>
                                </el-card>
                            </el-timeline-item>
                            <!-- moment(item.createDate.toString(), 'X').format('DD MMMM YYYY') -->
                            <!-- v-if="item.actionType == 'Started'" -->
                            <el-timeline-item
                                    v-for="(item, index) in progressData"
                                    :key="item.id"
                                    :timestamp="moment(item.createDate.toString(), 'X').format('LLLL') + ' ' + item.creatorCompanyUser.user.fullName"
                                    placement="top">
                                <!--{{stateId}}<br>-->
                                <!--{{item.id}}-->
                                <div :id="item.id" :ref="item.id">
                                    <el-card class="card">
                                        <div slot="header" class="card__header">
                                            <div class="photo-group">
                                                <img v-if="item.creatorCompanyUser.user.avatarUrl" :src="item.creatorCompanyUser.user.avatarUrl">
                                            </div>
                                            <div class="card__status">
                                                <el-tag size="small" type="success" style="margin-right: 10px;" v-html="item.actionType === 'In Progress' ?  $t('inProgress') : $t(item.actionType)"></el-tag>
                                            </div>
                                            <div v-if="item.actionType != 'Started'" class="card__progress">
                                                <el-progress :text-inside="true" :stroke-width="18" :percentage="Math.round(item.progress)"></el-progress>
                                            </div>
                                            <div v-if="item.actionType != 'Started'" class="card__time">
                                                {{$t('project_tab_progress_first_taskTime')}}: {{item.hoursSpent}}:{{item.minutesSpent}}
                                            </div><br>
                                            <!--{{item.id}}-->
                                            <div class="card__edit">
                                                <!-- TODO -->
                                                <el-button v-show="item.actionType == 'In Progress'" type="warning" plain size="mini" @click="openModalAddRemarks(item.id)">Add Remarks</el-button>
                                                <el-button :disabled="!projectPermission.editProgress" v-show="(item.actionType == 'In Progress' && index == 0) || item.editProgress" @click="editProgress(item.id)" type="primary" plain size="mini" icon="el-icon-edit"></el-button>
                                                <el-button :disabled="!projectPermission.deleteProgress" v-show="item.actionType == 'In Progress' && index == 0" @click="deleteProgress(item.id)" type="danger" plain size="mini" icon="el-icon-delete"></el-button>
                                            </div>
                                        </div>
                                        <div v-if="item.isReminderActive === 1" class="reminder-row">
                                            <font-awesome-icon icon="bell"/> {{$t('project_tab_progress_first_reminderSet')}}:
                                            <div class="reminder-date" v-if="item.reminderDate !== null">
                                                {{moment(item.reminderDate, 'X').format('lll')}}
                                            </div>

                                        </div>
                                        <div v-if="item.isBillable" slot="header" class="billing-details">
                                            <div class="billing-details__title">
                                                <img src="@/assets/img/info/dollar-sign.svg" width="20px;" style="margin-right: 5px;">
                                                <strong>Billing Details:</strong>
                                            </div>
                                            <div>
                                                <strong>Assignment:</strong> {{ item.assignment ? item.assignment.name : '' }}
                                            </div>
                                            <div>
                                                <strong>Activity:</strong> {{ item.activity ? item.activity.name : '' }}
                                            </div>
                                            <div>
                                                <strong>Short Note:</strong> {{ item.title }}
                                            </div>
                                        </div>
                                        <div class="text item">
                                            <div class="notifications">
                                                <div class="notifications_box">
                                                    <div v-if="item.clientNotificated" class="notifications_clients">{{$t('project_tab_progress_first_notifyClients')}}: <i class="el-icon-success" style="color: green;"></i></div>
                                                    <div v-if="item.vendorNotificated" class="notifications_vendors">{{$t('project_tab_progress_first_notifyVendors')}}: <i class="el-icon-success" style="color: green;"></i></div>
                                                </div>
                                            </div>
                                            <div>
                                                <p style="margin: 0;"><strong>{{$t('project_tab_progress_first_notes')}}:</strong></p>
                                                <div v-html="item.text" class="info-progress"></div>
                                                <!--{{item.id}}-->
                                            </div>
                                        </div>

                                        <!-- Remarks -->
                                        <el-timeline-item
                                                v-for="item in item.remarks"
                                                :key="item.id"
                                                :timestamp="moment(item.createDate.toString(), 'X').format('LLLL') + ' ' + item.user.firstName + ' ' + item.user.lastName"
                                                placement="top">
                                            <div :id="item.id" :ref="item.id">
                                                <el-card class="card">

                                                    <div slot="header" class="card__header">
                                                        <div class="photo-group">
                                                            <img v-if="item.user.avatarUrl" :src="item.user.avatarUrl">
                                                        </div>
                                                        <div class="card__status">
                                                            <el-tag size="small" type="warning" style="margin-right: 10px;">Remarks</el-tag>
                                                        </div>
                                                    </div>

                                                    <div class="text item">
                                                        <div>
                                                            <p style="margin: 0;"><strong>{{$t('project_tab_progress_first_notes')}}:</strong></p>
                                                            <div class="info-progress">
                                                                <p v-html="item.text"></p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </el-card>
                                            </div>

                                        </el-timeline-item>
                                        <!-- Remarks -->

                                    </el-card>
                                </div>

                            </el-timeline-item>

                        </el-timeline>
                    </div>

                    <CreateProjectTaskProgressModal :parentBill="parentBill" :projectPermission="projectPermission" @submit="getProjects" ref="modal2" :allowNotification="allowNotification" :selectedRow="selectedRow" :activeProjectId="activeProjectId" :assignmentList="assignmentList"/>
                    <AddProgressNote @submit="getProjects" ref="modal3" :allowNotification="allowNotification" :selectedRow="selectedRow" :activeProjectId="activeProjectId" :stopTime="stopTime"/>
                    <Progress :parentBill="parentBill" ref="modal666" @submit="getProjects" :activeProjectId="activeProjectId" :stopTime="stopTime" :progress="progress" :assignmentList="assignmentList"/>

                    <sweet-modal blocking title="Add remarks" ref="addRemark" v-on:close="resetForm('remark')">

                        <el-form :model="remark" :rules="rules" status-icon ref="remark" class="demo-ruleForm">
                            <el-form-item prop="remarkText">
                                <el-input type="textarea" v-model="remark.remarkText"></el-input>
                            </el-form-item>

                            <el-form-item class="modal__btn">
                                <el-button @click="modalCancel('addRemark')">{{$t('general_cancel')}}</el-button>
                                <el-button @click="addRemarks('remark')" type="primary">{{$t('general_submit')}}</el-button>
                            </el-form-item>
                        </el-form>

                    </sweet-modal>

                    <!-- [ Modal: Start, Done, Hold, Reopen ] start -->
                    <sweet-modal blocking :title="title" ref="startTask" v-on:close="closeModal">
                        <!-- <h1 v-if="doneTask === 'start'" >Start Task</h1>
                        <h1 v-else-if="doneTask === 'done'" >Done Task</h1>
                        <h1 v-else-if="doneTask === 'hold'" >Hold Task</h1>
                        <h1 v-else-if="doneTask === 'restart'" >Reopen Task</h1> -->

                        <el-form label-position="top" label-width="0" :model="form" status-icon ref="form" class="demo-ruleForm">
                            <el-form-item>
                              <vue2-custom-editor
                                  ref="editor"
                                  v-model="form.text">
                              </vue2-custom-editor>
                                <!--<el-input-->
                                        <!--type="textarea"-->
                                        <!--:rows="2"-->
                                        <!--placeholder="Please input"-->
                                        <!--v-model="form.text">-->
                                <!--</el-input>-->
                            </el-form-item>

                            <div style="display: flex;">
                                <el-form-item label-width="0">
                                    <el-switch :disabled="true" v-model="form.notifyProjectTeam" style="margin-right: 10px;" :active-text="$t('project_tab_progress_first_notifyManagementTeam')"></el-switch>
                                </el-form-item>
                                <el-form-item label-width="0">
                                    <el-switch v-model="form.notifyTaskTeam" style="margin-right: 10px;" :active-text="$t('project_tab_progress_first_notifyTaskTeam')"></el-switch>
                                </el-form-item>
                                <el-form-item label-width="0">
                                    <el-switch  :disabled="allowNotification" v-model="form.notifyClients" style="margin-right: 10px;" :active-text="$t('modal_notifyClients')"></el-switch>
                                </el-form-item>
                                <el-form-item label-width="0">
                                    <el-switch :disabled="allowNotification" v-model="form.notifyVendors" style="margin-right: 10px;" :active-text="$t('modal_notifyVendors')"></el-switch>
                                </el-form-item>
                            </div>

                            <el-form-item v-show="showProgressWhenRestart" :label="$t('project_tab_progress_first_progress')" prop="Progress" >
                                <el-slider v-model="form.progress"
                                        :max="100"
                                        :min="0"
                                        :step="5"
                                        show-stops>
                                </el-slider>
                            </el-form-item>

                            <el-form-item class="modal__btn">
                                <el-button @click="modalCancel('startTask')">{{$t('general_cancel')}}</el-button>
                                <el-button v-if="doneTask === 'start'" @click="startTask" type="primary">{{$t('general_submit')}}</el-button>
                                <el-button v-else-if="doneTask === 'done'" @click="doneTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>
                                <el-button v-else-if="doneTask === 'hold'" @click="holdTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>
                                <el-button v-else-if="doneTask === 'restart'" @click="restartTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>
                            </el-form-item>
                        </el-form>

                    </sweet-modal>
                    <!-- [ Modal: Start, Done, Hold, Reopen ] end -->

                    <!-- [ Modal are you sure ] start -->
                    <!-- <sweet-modal blocking ref="confirmation" title="Delete Progress">
                        Are you sure you want to delete this progress item?
                        <template slot="box-action">
                            <a class="button" @click="deleteProgressItem()">Ok</a> &nbsp;
                            <a class="button" @click="$refs.confirmation.close()">Cancel</a>
                        </template>
                    </sweet-modal> -->
                    <!-- [ Modal are you sure ] end -->

                    <!-- [ Modal form Edit Progress ] start -->
                    <EditProgress :parentBill="parentBill" @submit="getProjects" ref="modal" :companyProgressItem="companyProgressItem" :activeProjectId="activeProjectId" :assignmentList="assignmentList" :prevProjectTaskProgress="prevProjectTaskProgress"/>
                    <!-- [ Modal form Edit Progress ] end -->

                <!-- </el-card>
            </el-tab-pane>
        </el-tabs> -->
        <!-- <div v-if="selectedRow.type !== 'project' && bookmarkList" class="book-mark-block pointer">
            <div>
                <div v-if="bookmarkList.progresses" @click="changeBookMark(bookmarkList.progresses, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>
                <div v-else @click="changeBookMark(bookmarkList.progresses, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>
            </div>
        </div> -->
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import {scroller} from 'vue-scrollto/src/scrollTo'
    // const firstScrollTo = scroller();
    let moment = require('moment');
    import axios from 'axios'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    import EditProgress from "@/components/Projects/progress/EditProgress.vue";
    import CreateProjectTaskProgressModal from '@/components/Projects/CreateProjectTaskProgressModal.vue';
    import AddProgressNote from '@/components/Projects/progress/AddProgressNote.vue'
    import Progress from '@/components/Projects/progress/Progress.vue'
    import { VueEditor } from 'vue2-editor'
  import Vue2CustomEditor from "../vue-2-custom-editor";
    export default  {
        name: 'progress-tab',
        components: {
          Vue2CustomEditor,
            CreateProjectTaskProgressModal,
            AddProgressNote,
            SweetModal,

            VueEditor,
            EditProgress,
            Progress,
        },
        created() {
            this.$store.dispatch('getCompanyLayout');
        },
        mounted(){
          // const parentContainer = document.getElementById("pane-taskInfoTab").parentNode
          //
          // parentContainer.addEventListener('scroll', this.handleScroll);
          switch (this.selectedRow.taskStatus) {
                case -1:
                this.hide = false
                break;
                case 1:
                this.hide = true
                this.startBtn = true,
                    this.addBtn = false,
                    this.doneBtn = false,
                    this.holdBtn = false,
                    this.reopenBtn = false,
                    this.timerBtn = false
                break;
                case 2:
                this.hide = true
                this.startBtn = false,
                    this.addBtn = true,
                    this.doneBtn = true,
                    this.holdBtn = true,
                    this.reopenBtn = false,
                    this.timerBtn = true
                break;
                case 3:
                this.hide = true
                this.startBtn = true,
                    this.addBtn = false,
                    this.doneBtn = false,
                    this.holdBtn = false,
                    this.reopenBtn = false,
                    this.timerBtn = false
                break;
                case 4:
                this.hide = true
                this.startBtn = false,
                    this.addBtn = false,
                    this.doneBtn = false,
                    this.holdBtn = false,
                    this.reopenBtn = true,
                    this.timerBtn = false
                break;
                case 5:
                  this.hide = true
                  this.startBtn = false,
                    this.addBtn = true,
                    this.doneBtn = true,
                    this.holdBtn = true,
                    this.reopenBtn = false,
                    this.timerBtn = true
                  break;
                default:
                // alert( 'Я таких значений не знаю' );
            }
          // this.$nextTick(function () {
          //   setTimeout(() => {
          //     if (this.stateId) this.selectActiveProgressNode(this.stateId)
          //   }, 1000);
          // })
        },
        props:['selectedTaskForInfo',
               // 'stateId',
               'selectedRowId',
                'activeProjectId',
               // 'progressData',
               // "isOnProgress",
               'selectedRow',
               'sharedProjecttaskNoteId',
                // 'bookmarkList',
                'projectPermission'],
        computed:{
            ...mapGetters([
              'getStateId'
            ]),
            taskStatus(){
                return this.selectedRow.taskStatus
            },
            progressData(){
                return this.$store.state.progressData
            },
            timerList(){
                return this.$store.getters.getTimerList
            },
            companyLayout() {
                return this.$store.getters.getCompanyLayout
            },
            title: function () {
                return (this.doneTask === 'start' && this.selectedRow.taskStatus != 3) ? this.$i18n.t('general_startTask') :
                    (this.doneTask === 'start' && this.selectedRow.taskStatus == 3) ? this.$i18n.t('general_restartTask') :
                    (this.doneTask === 'done') ? this.$i18n.t('general_doneTask') :
                    (this.doneTask === 'hold') ? this.$i18n.t('general_holdTask') :
                    (this.doneTask === 'restart') ? this.$i18n.t('general_reopenTask') : ''
            }
        },
        data(){
            return{
                stopTime: '00:00',
                progress: 0,
                activeStar: 'el-icon-star-on',
                notActiveStar: 'el-icon-star-off',
                parentBill: false,
                assignmentList: [],
                prevProjectTaskProgress: 0,

                allowNotification: false,
                companyProgressItem: null,
                progressId: 0,
                totalTimeH: 0,
                totalTimeM: 0,
                moment:moment,
                startBtn: false,
                addBtn: false,
                doneBtn: false,
                holdBtn: false,
                reopenBtn: false,
                timerBtn: false,
                hide: true,
                showProgressWhenRestart: false,
                reopenBTN: true,
                progressStatus: '',
                form:{
                    text: "",
                    notifyProjectTeam: true,
                    notifyTaskTeam: true,
                    notifyClients: false,
                    notifyVendors: false,
                    progress:0
                },
                disabledBtn: true,
                doneTask: 'start',

                remark: {
                    remarkText: '',
                },
                rules: {
                    remarkText: [
                        { required: true, message: 'Please input remark', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            // Add Remarks
            openModalAddRemarks(progressId) {
                this.progressId = progressId
                this.$refs.addRemark.open()
            },
            addRemarks(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let loader = this.$loading.show();
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                        axios.post(`/api/v1/progress-remark/create`, {
                                progressId: this.progressId,
                                type: 'project',
                                text: this.remark.remarkText,
                            })
                            .then(response => {
                                this.getProgressesList()
                                this.$refs.addRemark.close();
                                this.notification("Success", "Add Remarks", "success");
                                loader.hide()
                            })
                            .catch(error => {
                                console.log('An error occurred:', error);
                                loader.hide()
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
          // async checkDistance(){
          //   const childNode = await new Promise((resolve) => resolve(document.getElementById('1180')));
          //   const parentContainer = await new Promise((resolve) => resolve(document.getElementById("pane-taskInfoTab").parentNode));
          //   console.log('parent', parentContainer.getBoundingClientRect());
          //   console.log('child', childNode.getBoundingClientRect());
          // },
          // handleScroll (event) {
          //   const parentContainer = document.getElementById("pane-taskInfoTab").parentNode
          //   console.log('1', parentContainer.scrollTop )
          // },
          async selectActiveProgressNode(stateId){
            try {

              const childNode = await new Promise((resolve) => resolve(document.getElementById(stateId.toString())));
              if (childNode) {
                const parentContainer = await new Promise((resolve) => resolve(document.getElementById("pane-taskInfoTab").parentNode));
                // get distance between blocks
                const distance = await this.countDistance(parentContainer.getBoundingClientRect(), childNode.getBoundingClientRect(), childNode.offsetTop, parentContainer.scrollTop);
                // console.log('distance', distance);
                parentContainer.scroll({
                  top: distance,
                  behavior: 'smooth'
                });
                // set active class to block
                await new Promise((resolve) => resolve(childNode.classList.add('hovered-node')));
                this.$store.dispatch('setStateId', null);
                setTimeout(() => {
                  childNode.classList.remove('hovered-node');
                }, 5000)
              }
            } catch (err){
              console.log(err)
            }
            },
            countDistance(parent, child, childOffsetTop, parentScrollTop){
            // console.log('childOffsetTop', childOffsetTop);
            // console.log('parent-top', parent);
            // console.log('child-top', child);
              return new Promise ((resolve) => {
                let distance = 0;
                if (parent.top < child.top){
                  distance = (child.top +  parentScrollTop) - parent.top - childOffsetTop;
                } else if (parent.top > child.top) {
                  distance = parentScrollTop - (parent.top - child.top + childOffsetTop)
                }
                resolve(distance || 0)
              })
            },
            modalCancel(ref) {
                this.$refs[ref].close();
            },
            timestamp(startDate, name) {
                if (startDate == null) {
                    return name
                } else {
                    return moment(startDate.toString(), 'X').format('DD MMMM YYYY') + ' ' + name
                }
            },
            // scroll(id){
            //     // alert(id)
            //     // scroller('#'+id)
            // },
          // changeBookMark(state, companyid, projectId, taskId){
          //   let data = this.bookmarkList;
          //   data.progresses = !this.bookmarkList.progresses;
          //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          //   axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
          //     .then(response => {
          //       if (this.bookmarkList.progresses) {
          //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
          //       } else {
          //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
          //       }
          //     })
          //     .catch(error => {
          //       console.log('An error occurred:', error);
          //     });
          // },
            deleteProgress(progressId) {
                this.progressId = progressId
                // this.$refs.confirmation.open();

                this.$confirm(this.$t('project_progresstab_thisWillPermanentlyDeleteProgressItemContinue'), this.$t('general_warning'), {
                    confirmButtonText: this.$t('general_ok'),
                    cancelButtonText: this.$t('general_cancel'),
                    type: 'info'
                }).then(() => {
                    this.$message({
                    type: 'success',
                    message: this.$t('general_delete')
                    });

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios.post(`/api/v1/projectTaskProgresses/delete?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskProgressId=${this.progressId}`)
                        .then(response => {
                            console.log('---', response.data);
                            this.getProgressesList()
                            this.getProjects()
                          // this.$store.dispatch('getProgressesList', this.selectedRowId)
                        //   this.notification(this.$i18n.t('notification_title_success'), "Delete Progress", "success")
                          this.$refs.confirmation.close();
                        })
                        .catch(error => {
                            // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info")
                            console.log('An error occurred:', error);
                        });
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                    });
                });
            },
            getProgressesList(){
              let data = {'taskId': this.selectedRowId, 'projectId': this.activeProjectId}
              this.$store.dispatch('getProgressesList', data)
            },
            // ! Clear
            // deleteProgressItem() {
            //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            //     axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            //     axios.post(`/api/v1/projectTaskProgresses/delete?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskProgressId=${this.progressId}`)
            //         .then(response => {
            //             console.log('---', response.data);
            //             this.getProgressesList()
            //             // this.$store.dispatch('getProgressesList', this.selectedRowId)
            //             this.$refs.confirmation.close();
            //             this.notification(this.$i18n.t('notification_title_success'), "Delete Progress", "success")
            //             this.getProjects()
            //         })
            //         .catch(error => {
            //             // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info")
            //             console.log('An error occurred:', error);
            //         });
            // },
            editProgress(progressId) {
                this.progressId = progressId;
                console.log('---', 'editProgress');
                this.$refs.modal.projectTaskId = this.selectedRowId;
                this.$refs['modal'].$refs['editProgressForm'].open();
                // this.itemRequest()

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTaskProgresses/directories?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskProgressId=${progressId}&operation=update`)
                    .then(response => {
                        if (response.data.allowExternalNotifications === 1){
                            this.allowNotification = false
                        }else{
                            this.allowNotification = true
                            this.form.notifyClients = false
                            this.form.notifyVendors = false
                        }
                        this.parentBill = response.data.parentBill !== 2 ? true : false
                        this.assignmentList = response.data.assignmentWithActivitiesList
                        this.prevProjectTaskProgress = +response.data.prevProjectTaskProgress.progress

                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                        axios
                            .post(`/api/v1/projectTaskProgresses/item?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskProgressId=${this.progressId}`)
                            .then(response => {
                                console.log('---/companyUsers/item', response.data);
                                this.companyProgressItem = response.data.item
                                this.$nextTick(() => {
                                    this.$refs['modal'].$refs['editor'].setImagesState()
                                })
                            })
                            .catch(error => {
                                console.log('An error occurred:', error);
                                // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info");
                            });
                    })
                    .catch(error => {
                    console.log('An error occurred:', error);
                    });
            },
            addProgressNote(){
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                // axios.post(`/api/v1/projectTaskProgresses/directories?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&operation=create`)
                //     .then(response => {
                //     if (response.data.allowExternalNotifications === 1){
                //         this.allowNotification = false
                //     }else{
                //         this.allowNotification = true
                //         this.form.notifyClients = false
                //         this.form.notifyVendors = false
                //     }
                //     })
                //     .catch(error => {
                //     console.log('An error occurred:', error);
                //     });

                this.itemRequest()
                this.$refs.modal2.projectTaskId = this.selectedRowId;
                this.$refs.modal2.$refs['createProjectTaskProgress'].open();
            },
            itemRequest(){
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/projectTaskProgresses/directories?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&operation=create`)
                .then(response => {
                    if (response.data.allowExternalNotifications === 1){
                        this.allowNotification = false
                    }else{
                        this.allowNotification = true
                        this.form.notifyClients = false
                        this.form.notifyVendors = false
                    }
                    this.parentBill = response.data.parentBill !== 2 ? true : false
                    this.assignmentList = response.data.assignmentWithActivitiesList
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
            },
          // handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
          //   let loader = this.$loading.show();
          //   console.log("FILE",file);
          //   // this.form.imageUrl = URL.createObjectURL(file.raw);
          //   // console.log('---', this.form.imageUrl);
          //   var formData = new FormData();
          //   formData.append('file', file);
          //
          //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          //   axios
          //     .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          //     .then(response => {
          //       let url = response.data.fileUrl // Get url from response
          //       Editor.insertEmbed(cursorLocation, 'image', url);
          //       resetUploader();
          //       loader.hide()
          //     })
          //     .catch(error => {
          //       console.log('An error occurred:', error);
          //       loader.hide()
          //     })
          // },
            startTaskOpenModal(){
                this.doneTask = 'start'
                this.itemRequest()
                this.$refs.startTask.open();
            },
            startTask(){
                console.log('START TASK')
                let data = {
                    text: this.form.text,
                    notifyProjectTeam: this.form.notifyProjectTeam,
                    notifyTaskTeam: this.form.notifyTaskTeam,
                    notifyClients: this.form.notifyClients,
                    notifyVendors: this.form.notifyVendors,
                }
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTasks/start?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}`, data)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("SUCCESS")
                            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskStarted'), "success");
                            loader.hide()
                            this.getProgressesList()
                            // this.$store.dispatch('getProgressesList', this.selectedRowId)
                            if (this.$refs.editor.uploadedImagesArray.length) {
                              this.$store.dispatch('approveUploadedImages', {
                                fileUrlArr: this.$refs.editor.uploadedImagesArray,
                                entityId: response.data.id,
                                entityTypeId: 30 // project task progress
                              })
                            }
                            // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                            this.$refs.startTask.close();
                            this.form.text = '';
                            this.form.notifyProjectTeam = true;
                            this.form.notifyTaskTeam = true;
                            this.form.notifyClients = false;
                            this.form.notifyVendors = false;
                        }
                        this.getProjects();
                        loader.hide()
                    })
                    .catch(error => {
                        // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info")
                        console.log('An error occurred:', error);
                        loader.hide()
                    });
            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type
                });

            },
            getProjects(){
                // alert(this.selectedRowId)
                this.$emit('submit', this.activeProjectId, false, this.selectedRowId)
            },
            doneTaskOpen(){
              if(this.selectedRow.timerCount){
                this.notification(this.$i18n.t('notification_title_warning'), "Stop Timer", "info")
                return
              }
                this.doneTask = 'done'
                this.itemRequest()
                this.$refs.startTask.open();
            },
            doneTaskSubmit(){
                console.log('DONE TASK')
                let data = {
                    text: this.form.text,
                    notifyProjectTeam: this.form.notifyProjectTeam,
                    notifyTaskTeam: this.form.notifyTaskTeam,
                    notifyClients: this.form.notifyClients,
                    notifyVendors: this.form.notifyVendors,
                }
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTasks/done?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}`, data)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("SUCCESS")
                            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskDone'), "success");
                            loader.hide()
                            this.getProgressesList()
                            if (this.$refs.editor.uploadedImagesArray.length) {
                              this.$store.dispatch('approveUploadedImages', {
                                fileUrlArr: this.$refs.editor.uploadedImagesArray,
                                entityId: response.data.id,
                                entityTypeId: 30 // project task progress
                              })
                            }
                            // this.$store.dispatch('getProgressesList', this.selectedRowId)
                            this.$refs.startTask.close();
                            this.form.text = '';
                            this.form.notifyProjectTeam = true;
                            this.form.notifyTaskTeam = true;
                            this.form.notifyClients = false;
                            this.form.notifyVendors = false;
                        }
                        this.getProjects();
                    })
                    .catch(error => {
                        // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info")
                        console.log('An error occurred:', error);
                        loader.hide()
                    });
            },
            holdTaskOpen(){
                if(this.selectedRow.timerCount){
                  this.notification(this.$i18n.t('notification_title_warning'), "Stop Timer", "info")
                  return
                }
                this.doneTask = 'hold'
                this.itemRequest()
                this.$refs.startTask.open();
            },
            holdTaskSubmit(){
                console.log('HOLD TASK')
                let data = {
                    text: this.form.text,
                    notifyProjectTeam: this.form.notifyProjectTeam,
                    notifyTaskTeam: this.form.notifyTaskTeam,
                    notifyClients: this.form.notifyClients,
                    notifyVendors: this.form.notifyVendors,
                }
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTasks/hold?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}`, data)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("SUCCESS")
                            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskHold'), "success");
                            loader.hide()
                            this.getProgressesList()
                            if (this.$refs.editor.uploadedImagesArray.length) {
                              this.$store.dispatch('approveUploadedImages', {
                                fileUrlArr: this.$refs.editor.uploadedImagesArray,
                                entityId: response.data.id,
                                entityTypeId: 30 // project task progress
                              })
                            }
                            // this.$store.dispatch('getProgressesList', this.selectedRowId)
                            this.$refs.startTask.close();
                            this.form.text = '';
                            this.form.notifyProjectTeam = true;
                            this.form.notifyTaskTeam = true;
                            this.form.notifyClients = false;
                            this.form.notifyVendors = false;
                        }
                        this.getProjects();
                    })
                    .catch(error => {
                        // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info")
                        console.log('An error occurred:', error);
                        loader.hide()
                    });
            },
            restartTaskOpen(){
                this.showProgressWhenRestart = true
                this.doneTask = 'restart'
                this.itemRequest()
                this.$refs.startTask.open();
            },
            restartTaskSubmit(){
                console.log('RESTART TASK')
                let data = {
                    text: this.form.text,
                    notifyProjectTeam: this.form.notifyProjectTeam,
                    notifyTaskTeam: this.form.notifyTaskTeam,
                    notifyClients: this.form.notifyClients,
                    notifyVendors: this.form.notifyVendors,
                    progress: this.form.progress
                }
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTasks/restart?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}`, data)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("SUCCESS")
                            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskReopened'), "success");
                            loader.hide()
                            this.getProgressesList()
                            // this.$store.dispatch('getProgressesList', this.selectedRowId)
                            if (this.$refs.editor.uploadedImagesArray.length) {
                              this.$store.dispatch('approveUploadedImages', {
                                fileUrlArr: this.$refs.editor.uploadedImagesArray,
                                entityId: response.data.id,
                                entityTypeId: 30 // project task progress
                              })
                            }
                            this.$refs.startTask.close();
                            this.form.text = '';
                            this.form.notifyProjectTeam = true;
                            this.form.notifyTaskTeam = true;
                            this.form.notifyClients = false;
                            this.form.notifyVendors = false;
                            this.form.progress = 0;
                        }
                        this.getProjects();
                    })
                    .catch(error => {
                        // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "info")
                        console.log('An error occurred:', error);
                        loader.hide()
                    });
            },
            timer() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTaskTimers/create?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}`)
                    .then(response => {
                        console.log('---projectTaskTimers/create', response.data);
                        this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRowId})
                        this.notification(this.$i18n.t('notification_title_success'), "Task start time", "success");
                        this.getProjects()
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                    });
            },
            pauseTimer(id, projectId, projectTaskId) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTaskTimers/pause?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskTimerId=${id}`)
                    .then(response => {
                        console.log('---/projectTaskTimers/pause', response.data);
                        this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: projectTaskId})
                        this.notification(this.$i18n.t('notification_title_success'), "Timer pause", "success");
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                    });
            },
            restartTimer(id, projectId, projectTaskId) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTaskTimers/restart?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskTimerId=${id}`)
                    .then(response => {
                        console.log('---/projectTaskTimers/restart', response.data);
                        this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: projectTaskId})
                        this.notification(this.$i18n.t('notification_title_success'), "Timer restart", "success");
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                    });
            },
            stopTimer(id, startTime, time, total) {
                this.itemRequest()
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTaskTimers/preStop?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRowId}&projectTaskTimerId=${id}`)
                    .then(response => {
                        console.log('---/projectTaskTimers/preStop', response.data);
                        let s = response.data.data.totalTime

                        let sec = s % 60
                        let min = Math.floor((s / 60) % 60)
                        let hour = Math.floor(s / 3600)

                        if (sec.toString().length < 2) {
                            sec = '0' + sec
                        }
                        if (min.toString().length < 2) {
                            min = '0' + min
                        }
                        if (hour.toString().length < 2) {
                            hour = '0' + hour
                        }

                        this.stopTime = hour + ':' + min
                        this.progress = Math.round(response.data.data.progress)

                        this.$refs.modal666.projectTaskId = this.selectedRowId;
                        this.$refs.modal666.projectTaskTimerId = id;
                        this.$refs.modal666.$refs['createProjectTaskProgress'].open();
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                    });
            },
            totalTime(startTime, time, total, status) {

                let s
                if (startTime === null) {
                    s = total
                } else {
                     s =  time - startTime + total
                }

                let sec = s % 60
                let min = Math.floor((s / 60) % 60)
                let hour = Math.floor(s / 3600)

                if (sec.toString().length < 2) {
                    sec = '0' + sec
                }
                if (min.toString().length < 2) {
                    min = '0' + min
                }
                if (hour.toString().length < 2) {
                    hour = '0' + hour
                }

                // this.time = hour + ':' + min + ':' + sec
                return hour + ':' + min
                //  + ':' + sec

            },
            closeModal(){
                this.showProgressWhenRestart = false;
                this.form.text = '';
                this.form.notifyProjectTeam = true;
                this.form.notifyTaskTeam = true;
                this.form.notifyClients = false;
                this.form.notifyVendors = false;
            },
        },
        beforeDestroy(){
            // alert("DESTROY")
        },
        watch:{
            taskStatus(val){
                switch (val) {
                    case -1:
                        this.hide = false
                        break;
                    case 1:
                        this.hide = true
                        this.startBtn = true
                        this.addBtn = false
                        this.doneBtn = false
                        this.holdBtn = false
                        this.reopenBtn = false
                        this.timerBtn = false
                        break;
                    case 2:
                        this.hide = true
                        this.startBtn = false
                        this.addBtn = true
                        this.doneBtn = true
                        this.holdBtn = true
                        this.reopenBtn = false
                        this.timerBtn = true
                        break;
                    case 3:
                        this.hide = true
                        this.startBtn = true
                        this.addBtn = false
                        this.doneBtn = false
                        this.holdBtn = false
                        this.reopenBtn = false
                        this.timerBtn = false
                        break;
                    case 4:
                        this.hide = true
                        this.startBtn = false
                        this.addBtn = false
                        this.doneBtn = false
                        this.holdBtn = false
                        this.reopenBtn = true
                        this.timerBtn = false
                        break;
                    case 5:
                        this.hide = true
                        this.startBtn = false
                        this.addBtn = true
                        this.doneBtn = true
                        this.holdBtn = true
                        this.reopenBtn = false
                        this.timerBtn = true
                    break;
                    default:
                }
            },
            progressData(){
                this.totalTimeH = 0
                this.totalTimeM = 0
                this.progressData.forEach(val => {
                  if(val.reminderDate !== null){
                    if (val.reminderDate.toString().length < 8) {
                      val.reminderDate = '0' + val.reminderDate.toString()
                    } else {
                      val.reminderDate = val.reminderDate.toString()
                    }
                  }
                if(val.hoursSpent.toString().length < 2){
                  val.hoursSpent = '0' + val.hoursSpent.toString()
                }
                if(val.minutesSpent.toString().length < 2){
                  val.minutesSpent = '0' + val.minutesSpent.toString()
                }
                    this.totalTimeH = this.totalTimeH + Number(val.hoursSpent)
                    this.totalTimeM = this.totalTimeM + Number(val.minutesSpent)

                    console.log('HOURS SPEND',val.hoursSpent)
                    switch (val.actionType) {
                        case 1:
                            val.actionType = "In Progress"
                            break;
                        case 2:
                            val.actionType = "Started"
                            break;
                        case 3:
                            val.actionType = "Reopened"
                            break;
                        case 4:
                            val.actionType = "Done"
                            break;
                        case 5:
                            val.actionType = "Hold"
                            break;
                        case 6:
                            val.actionType = "Restarted"
                            break;
                        default:
                        // alert( 'Я таких значений не знаю' );
                    }
                    //
                    // if(val.actionType === 2){
                    //     console.log("PROBALY")
                    //     val.actionType = "FACK OFFF"
                    // }
                  console.log('VAL', val)
                })

                this.totalTimeH = this.totalTimeH + ((this.totalTimeM - this.totalTimeM % 60) / 60)
                this.totalTimeM = this.totalTimeM % 60
                // this.totalTimeH = this.totalTimeH + ((this.totalTimeM - this.totalTimeM % 60) / 60)
              // console.log('totalTime length', this.totalTimeH.toString().length)
              // console.log('totalTime length', this.totalTimeM.toString().length)
              if(this.totalTimeH.toString().length < 2){
                this.totalTimeH = '0' + this.totalTimeH.toString()
              }
              if(this.totalTimeM.toString().length < 2){
                this.totalTimeM = '0' + this.totalTimeM.toString()
              }
            },
            // getStateId(val){
            //   if (val) {
            //     this.selectActiveProgressNode(val)
            //   }
            // }
        }
    }
</script>

<style lang="less" scoped>
    .buttons{
        // padding-top: 35px;
        display: flex;
        justify-content: space-between;
        // margin-bottom:15px;
    }
    .startedtask{
        display:none;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    .box-card{
        margin:20px 0;
    }
    .text {
        position: relative;
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
        display:flex;
        & > div{
            width:100%;
        }
    }

    .notifications {
        position: absolute;
        top: 0; /* Положение от нижнего края */
        right: 0;
        &_box {
            display: flex;
            justify-content: flex-end;
        }
        &_clients{
            margin-right: 10px;
        }
        &_vendors{

        }
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .card {
        .photo-group{
            overflow:hidden;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 20px;
            background: url('~@/assets/img/user-default.jpg');
            background-size: cover;
            img{
                width:100%;
                height:100%;
            }
        }
        &__header {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .reminder-row{
            color:red;
            margin-bottom: 20px;
            .reminder-date{
                color:grey;
            }
        }
        &__status {

        }
        &__progress {
            width: 150px;
            // flex: 1;
            margin-right: 10px;
        }
        &__edit {
            margin-left: auto;
        }
        &__time {
            display: flex;
            align-items: center;
        }
    }
    .timer {
        background: #f2f2f2;
    }

    // [ Modal ] start
    .button{
        cursor: pointer;
    }
    // [ Modal ] end
    .hovered-node{
        -webkit-box-shadow: 0 0 26px 5px #409EFF;
        box-shadow: 0 0 10px 5px #409EFF;
    }
</style>

<style lang="less" scoped>
    .flex-twocolumn{
        display:flex;
        .el-form-item__content{
            margin:0 12px;
            font-size:13px;
            &:first-child {
                margin-left: 0px;
            }
        }
    }
    /deep/ ul.el-timeline {
      padding-inline-start: 0px;
    }
</style>

<style lang="scss">
.info-progress{
    p{
        img{
            max-width: 100%;
        }
    }
}
</style>
